import { BaseModel } from '../base.model';

export class MileageRuleDto extends BaseModel {
  /** GUID */
  MileageRuleID: string | null;
  ParentFacilityID: number | null;
  ParentFacilityName: string | null;
  /** GUID */
  JobID: string | null;
  VpJobID: string | null;
  JobName: string | null;
  StartDate: Date;
  EndDate: Date | null;
  MinimumTripMiles: number | null;
  MaxTripsPerProject: number | null;
  DemobilizationResetWorkingDays: number | null;
  Notes: string | null;
  bActive: boolean;
  LastModifiedAt: Date | null;
  LastModifiedAtDateOnly: Date | null;
  LastModifiedBy: string | null;
  /** Populated on save requests and single-rule reads; the OData grid rows carry no tiers. */
  CapTiers: MileageRuleCapTierDto[] | null;

  constructor(o: any = null) {
    super(o);
  }
}

export class MileageRuleWarningDto extends BaseModel {
  /** GUID */
  EmployeeJobID: string;
  EmployeeName: string;
  VpJobID: string | null;
  JobName: string | null;
  DateWorked: Date | null;
  Messages: string[];
  RuleScope: string;
  RuleDescription: string;
  LastWorkedDate: Date | null;
  WorkingDaysSinceLastWorked: number | null;
  ExistingMileageRecords: MileageRuleExistingMileageDto[];
  IncomingMileageRecords: MileageRuleExistingMileageDto[];

  constructor(o: any = null) {
    super(o);
  }
}

export class MileageRuleExistingMileageDto extends BaseModel {
  DateWorked: Date | null;
  MileageType: string;
  Miles: number | null;
  CountsTowardTripLimit: boolean;

  constructor(o: any = null) {
    super(o);
  }
}

export class MileageRuleCapTierDto extends BaseModel {
  /** GUID */
  MileageRuleCapTierID: string | null;
  /** GUID */
  MileageRuleID: string | null;
  FromMiles: number;
  ToMiles: number | null;
  CapAmountEachWay: number;
  bActive: boolean;

  constructor(o: any = null) {
    super(o);
  }
}
